import { FormTitle } from 'components/common/FormTitle'
import Loader from 'components/common/Loader'
import './style.styl'

export function LoadingPicture() {
  return (
    <div className="loading-picture">
      <div className="loading-picture__container">
        <Loader />
        <FormTitle
          title="Estamos processando sua imagem"
          description="Aguarde uns instantes"
        />
      </div>
    </div>
  )
}
